import axios from 'axios'
import { Cookie } from '@/mixin/local-cookie'

const axiosConfig = {
  baseURL: process.env.VUE_APP_REST_API_IDENTITY,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    namespace: 'identity'
  },
}

const localCookie = Cookie.getLocalCookie()

if (localCookie?.resource) {
  axiosConfig.headers.Authorization = `Bearer ${localCookie?.resource}`
} else {
  axiosConfig.withCredentials = true
}

const apiClient = axios.create(axiosConfig)

apiClient.interceptors.response.use(
  function (response) {
    return response
  }
)

export default apiClient
